export const howToMakeAPaymentPage = {
   heading: 'how-to-make-a-payment-page-heading',
   sectionHeading: 'how-to-make-a-payment-heading',
   sectionBody: 'how-to-make-a-payment-section-body'
};
